import { Link } from "react-router-dom";
import { HeartHandshake, HandHeart } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTASection = () => (
  <section className="bg-hecso-greendark" data-testid="cta-section">
    <div className="container-hecso py-14 sm:py-16">
      <Reveal className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
        <div className="max-w-2xl">
          <h2 className="text-2xl sm:text-3xl font-semibold text-white tracking-tight">
            Your support can change a life today
          </h2>
          <p className="mt-3 text-sm sm:text-base text-white/80 leading-relaxed">
            Every contribution helps us organize health camps, screen school children, train women and reach
            families who need care the most. Join us in building healthier communities across Assam.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/donate"
            data-testid="cta-donate-btn"
            className="inline-flex items-center gap-2 rounded-lg bg-hecso-orange px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-hecso-orangehover hover:-translate-y-0.5 active:scale-95"
          >
            <HeartHandshake className="w-4 h-4" /> Donate Now
          </Link>
          <Link
            to="/get-involved"
            data-testid="cta-volunteer-btn"
            className="inline-flex items-center gap-2 rounded-lg border border-white/40 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white hover:text-hecso-greendark"
          >
            <HandHeart className="w-4 h-4" /> Become a Volunteer
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
